import { ReactNode, useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/button/button';
import FilterFunnel from '@/assets/icons/filter-funnel-01.svg?react';
import ChevronDown from '@/assets/icons/chevron-down.svg?react';
import ChevronUp from '@/assets/icons/chevron-up.svg?react';
import styles from './filters-disclosure.module.scss';

interface FiltersDisclosureProps {
  /** Count of filters the panel hides, rendered in the trigger label. */
  activeCount: number;
  children: ReactNode;
  className?: string;
}

/** Inline disclosure for filters the toolbar row has no space for. */
export default function FiltersDisclosure({
  activeCount,
  children,
  className,
}: FiltersDisclosureProps) {
  const { t } = useTranslation('common');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        aria-expanded={isOpen}
        buttonVariant="secondary"
        className={clsx(styles.trigger, className)}
        icon={<FilterFunnel className={styles.glyph} />}
        onClick={() => setIsOpen((wasOpen) => !wasOpen)}
      >
        {activeCount > 0 ? t('filters.moreActive', { active: activeCount }) : t('filters.more')}
        {isOpen ? <ChevronUp className={styles.glyph} /> : <ChevronDown className={styles.glyph} />}
      </Button>
      {/* No `aria-controls`: the panel is unmounted while collapsed, so the attribute
          would name an id that is not in the document. `aria-expanded` on a trigger
          immediately followed by its panel carries the state on its own. */}
      {isOpen && <div className={styles.panel}>{children}</div>}
    </>
  );
}
